const colors = {
  yellow: '#F9B142',
  blue: '#0088CC',
  green: '#85A91A',
  purple: '#BB68D9',
  red: '#C80000'
};

export default {
  /* Cloverbook */
  con: colors.blue,
  est: colors.yellow,
  pro: colors.purple,
  inv: colors.red,
  /* audio */
  mp3: colors.purple,
  aiff: colors.purple,
  wav: colors.purple,
  ogg: colors.purple,
  /* video */
  mov: colors.green,
  mp4: colors.green,
  mpg: colors.green,
  mpeg: colors.green,
  vob: colors.green,
  mkv: colors.green,
  avi: colors.green,
  m4v: colors.green,
  /* documents */
  doc: colors.blue,
  docx: colors.blue,
  xls: colors.green,
  xlsx: colors.green,
  csv: colors.green,
  ppt: colors.red,
  pptx: colors.red,
  key: colors.yellow,
  pdf: colors.red,
  txt: colors.blue,
  rtf: colors.yellow,
  odt: colors.blue,
  /* images */
  jpg: colors.yellow,
  jpeg: colors.yellow,
  gif: colors.yellow,
  png: colors.yellow,
  psd: colors.blue,
  bmp: colors.blue,
  svg: colors.blue,
  tif: colors.blue,
  tiff: colors.blue,
  /* executable and other */
  zip: colors.blue,
  dmg: colors.yellow,
  bin: colors.yellow,
  exe: colors.yellow,
  gz: colors.yellow
};



// WEBPACK FOOTER //
// ./webpack/components/Elements/FileIcon/ExtensionColors.js